@if (validationErrors) {
  <h1>Validációs hibák</h1>
  <ul>
    @for (error of validationErrors.errors | keyvalue; track error.key) {
      @for (message of error.value; track message) {
        <li>{{ message }}</li>
      }
    }
  </ul>
}
